import { render, staticRenderFns } from "./CorpInformationForm.vue?vue&type=template&id=993f700c&scoped=true&"
import script from "./CorpInformationForm.vue?vue&type=script&lang=ts&"
export * from "./CorpInformationForm.vue?vue&type=script&lang=ts&"
import style0 from "./CorpInformationForm.vue?vue&type=style&index=0&id=993f700c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993f700c",
  null
  
)

export default component.exports